import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent, TreeNode } from 'primeng/primeng';
import { tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { SpinnerService } from './spinner.service';
import { CostCenterService } from './cost-center.service';
import { PayrollResultService } from './payroll-result.service';
import { CostCenter } from '../entities/costCenter';
import { PayrollResult } from '../entities/payroll-result';
import { PayrollTreeNode } from '../entities/payroll-treeNode';
import { PayrollResultType } from 'app/shared/_utils/services/PayrollResultType.enum';

@Injectable()
export class PayrollResultDeleteService {

    protected rutaServidor = localStorage.getItem('rutaServidor');
    protected httpParams = new HttpParams();
    protected uri = '/api/payrollResultTreeNode/';
    totalIncome: number;
    totalDeduction: number;
    contratoAmount: number;

    constructor(
        private httpClient: HttpClient,
        private costCenterService: CostCenterService,
        private payrollResultService: PayrollResultService,
        private spinnerService: SpinnerService
    ) {
       // console.log('Instance PayrollTreeNodeService');
    }

    loadCostCenter(): Observable<ResponsePageable<CostCenter>> {
        return this.costCenterService.search();
    }

    loadPayrollResult(payrollTreeNode: PayrollTreeNode): Observable<ResponsePageable<PayrollResult>> {
        const payrollResult = new PayrollResult();
        payrollResult.costCenter = payrollTreeNode.costCenter;
        return this.payrollResultService.search(payrollTreeNode);
    }

    buildSentence(entity?: PayrollTreeNode, event?: LazyLoadEvent): HttpParams {
        if (event) {
            const page = ((event.first + event.rows) / event.rows - 1).toString();
            const size = event.rows.toString();
            this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
            this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
        }
        return this.httpParams;
    }

    search(
        fiscalYear: any,
        executingUnit: any,
        month: any,
        employeeType: any,
        payrollType: any,
        employee: any,
        costCenter: any): Observable<ResponsePageable<PayrollTreeNode>> {
            const params = new HttpParams()
            .set('fiscalYearId', fiscalYear)
            .set('euId', executingUnit)
            .set('payrollTypeId', payrollType)
            .set('employeeTypeId', employeeType)
            .set('monthId', month)
            .set('costCenterId', costCenter)
            .set('employeeId', employee)

        const url = `${this.rutaServidor}${this.uri}search`;
        this.spinnerService.showAll();
        return this.httpClient
            .get<ResponsePageable<PayrollTreeNode>>(url, { params: params })
            .pipe(
                tap(response => {
                   // console.log(response);
                    this.spinnerService.hideAll();
                    return response;
                })
            );
    }

    toTreeNode(payrollResults: PayrollTreeNode[]): TreeNode[] {
        this.totalIncome = 0;
        this.totalDeduction = 0;
        this.contratoAmount = 0;
        payrollResults.forEach(element => {
            this.totalIncome = this.totalIncome + element.payrollResult.totalIncome;
            this.totalDeduction = this.totalDeduction + element.payrollResult.totalDeductions;
            this.contratoAmount = this.contratoAmount + element.payrollResult.contractAmount;
        });
        return this.bindCostCenters(payrollResults);
    }

    private bindCostCenters(payrollResults: PayrollTreeNode[]): TreeNode[] {
        const treeNodes: TreeNode[] = [];
        let auxCostCenterId = 0;
        payrollResults.forEach((payrollTreeNode) => {
            if (auxCostCenterId !== payrollTreeNode.costCenter.id) {
                const treeNode = {
                    data: {value: payrollTreeNode.costCenter, type: PayrollResultType.CostCenter},
                    expanded: true,
                    children: this.bindPayrollResults(payrollResults, payrollTreeNode.costCenter)
                }
                treeNodes.push(treeNode);
                auxCostCenterId = payrollTreeNode.costCenter.id;
            }
        })
        return treeNodes;
    }

    private bindPayrollResults(PayrollTreeNodes: PayrollTreeNode[], costCenter: CostCenter): TreeNode[] {
        const treeNodes: TreeNode[] = [];
        PayrollTreeNodes.forEach((payrollTreeNode: PayrollTreeNode) => {
            if (
                payrollTreeNode.costCenter
                && payrollTreeNode.costCenter.id === costCenter.id
            ) {
                let treeNode: TreeNode;
                treeNode = {
                    data: {value: payrollTreeNode.payrollResult, type: PayrollResultType.PayrollResult}
                }
                treeNodes.push(treeNode);
            }
        })
        return treeNodes;
    }

    deletePayrollResult(payrollResultId: number[]): Observable<any> {
        const url = `${this.rutaServidor}${this.uri}delete`;
        return this.httpClient.post(url, payrollResultId);
    }

    isCostCenter(type: string) {
        return PayrollResultType.CostCenter === type;
    }

    isPayrolResult(type: string) {
        return PayrollResultType.PayrollResult === type;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/payroll-result-delete.service.ts